export const appBaseURL = "/au-community/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"renderer","content":"webkit"},{"name":"viewport","content":"width=device-width,initial-scale=1, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover"},{"hid":"description","name":"description","content":""},{"hid":"keywords","name":"keywords","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"name":"robots","content":"all"},{"name":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"name":"cleartype","content":"on"},{"name":"renderer","content":"webkit"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/au-community/logo_icon.png"},{"rel":"icon","type":"image/x-icon","href":"/au-community/init-font.css"}],"style":[],"script":[{"src":"/au-community/init-fontsize.js"},{"src":"/au-community/vconsole.min.js","type":"text/javascript"},{"innerHTML":"var env = env = [\"aus-h5-front-test.gwmcloud.com\"]; if (env.includes(location.host) || process.dev) {new VConsole()}"}],"noscript":[],"title":"‎","htmlAttrs":{"lang":"en_US"}}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = false

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const vueAppRootContainer = '#__nuxt'